import { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import emailjs from '@emailjs/browser';

const Contacto = () => {
  const SERVICE_ID = 'service_mvvalzh';
  const TEMPLATE_ID = 'template_7u4x8jv';
  const PUBLIC_KEY = 'wWIOQBwxMjljd-nOG';

  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    asunto: '',
    mensaje: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const isSendingRef = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    emailjs.init(PUBLIC_KEY);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (isSendingRef.current) return;

    const templateParams = {
      title: formData.telefono,
      name: formData.nombre,
      email: formData.email,
      message: formData.mensaje,
      time: new Date().toLocaleString('es-ES')
    };

    isSendingRef.current = true;
    setIsSending(true);

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams)
      .then((response) => {
        console.log('Email enviado exitosamente', response.status, response.text);
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          mensaje: ''
        });
        isSendingRef.current = false;
        setIsSending(false);
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
        }, 3000);
      })
      .catch((sendError) => {
        console.error('Error al enviar email:', sendError);
        isSendingRef.current = false;
        setIsSending(false);
        setError('Error al enviar el mensaje. Intenta de nuevo.');
      });
  };

  return (
    <Container className="py-5">
      <Row className="mb-5">
        <Col md={6}>
          <h3>Información de Contacto</h3>
          <div className="contact-info">
            <p>
              <strong>Empresa:</strong> Goyanes Somoza SL
            </p>
            <p>
              <strong>Teléfono:</strong> <a href="tel:+34982530274">+34 982 530 274</a>
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:goyanes@goyanessomoza.com">goyanes@goyanessomoza.com</a>
            </p>
            <p>
              <strong>Dirección:</strong> Poligono Industrial Morelle, Parcela 23, 27614, Sarria (Lugo)
            </p>
            <p>
              <strong>Horario:</strong> Lunes a Viernes 9:00 - 13:30, 15:30 - 19:00
            </p>
            <h3 className="mt-4">Ubicación</h3>
            <iframe
              title="Mapa de Goyanes Somoza"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3564.2086678436763!2d-7.383289287866916!3d42.79666390728568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd304893d0abc791%3A0xcb2c16b7559cc590!2sGoyanes%20Somoza%20SL!5e1!3m2!1ses!2ses!4v1779811804153!5m2!1ses!2ses"
              width="100%"
              height="350"
              style={{ border: 0, borderRadius: '8px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Col>

        <Col md={6}>
          <h3>Formulario de Contacto</h3>
          {submitted && (
            <Alert variant="success">
              ¡Gracias por tu mensaje! Nos pondremos en contacto pronto.
            </Alert>
          )}
          {error && (
            <Alert variant="danger">
              {error}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                placeholder="Tu nombre"
                required
                disabled={isSending}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="tu@email.com"
                required
                disabled={isSending}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="tel"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="Tu teléfono"
                disabled={isSending}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Mensaje</Form.Label>
              <Form.Control
                as="textarea"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                placeholder="Escribe tu mensaje aquí"
                rows={4}
                required
                disabled={isSending}
              />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={isSending}>
              {isSending ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                  Enviando...
                </>
              ) : (
                'Enviar Mensaje'
              )}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contacto;
